import { createContext } from 'react';

import { UserProfile } from '../getUserProfile/index.js';

export const ClientProfileContext = createContext<UserProfile | null>(null);
